import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import Geoprocessor from '@arcgis/core/tasks/Geoprocessor';
import { appConfig } from 'cd-eft/config/AppConfig';
import { GroupLayer, SpatialReference } from 'cd-eft/utils/esriTypes';

const __serviceUrl = appConfig.surfaceDesignGpApiConfig.basePath + appConfig.surfaceDesignGpApiConfig.JsonToSurface;

interface IContourPoint {
  x: number;
  y: number;
}
interface IContourLine {
  elevation: number;
  points: IContourPoint[];
  major: boolean;
}

export async function getDemAndHillshadeLayerFromContours(
  contourLines: IContourLine[],
  projectSR: SpatialReference
): Promise<GroupLayer> {
  const gp = new Geoprocessor({ url: __serviceUrl });
  let params;
  if (projectSR.wkid) {
    params = {
      input_wkid: projectSR.wkid,
      input_json: contourLines,
    };
  } else if (projectSR.wkt) {
    params = {
      input_wkt: projectSR.wkt,
      input_json: contourLines,
    };
  }
  let jobInfo = await gp.submitJob(params);
  jobInfo = await gp.waitForJobCompletion(jobInfo.jobId);
  const mapImageLayer = await gp.getResultMapImageLayer(jobInfo.jobId);

  const demLayer = mapImageLayer;
  const hillshadeLayer = new MapImageLayer({ url: demLayer.url });

  const p1 = demLayer.loadAll();
  const p2 = hillshadeLayer.loadAll();
  await p1;
  await p2;

  demLayer.title = 'DEM';
  demLayer.listMode = 'hide-children';
  demLayer.opacity = 0.7;
  demLayer.allSublayers.forEach((sublayer) => {
    if (sublayer.title === 'output_dem') {
      sublayer.visible = true;
    } else {
      sublayer.visible = false;
    }
  });

  hillshadeLayer.title = 'Hillshade';
  hillshadeLayer.listMode = 'hide-children';
  hillshadeLayer.opacity = 0.7;
  hillshadeLayer.allSublayers.forEach((sublayer) => {
    if (sublayer.title === 'output_hillshade') {
      sublayer.visible = true;
    } else {
      sublayer.visible = false;
    }
  });

  const groupLayer = new GroupLayer({ layers: [hillshadeLayer, demLayer] });

  groupLayer.title = 'DEM & Hillshade';

  return groupLayer;
}
